query ContractPaymentsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: ContractPaymentsFilterInput
) {
  contractPayments(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      contractId
      contract {
        id
        title
        currency
      }
      organizationId
      organization {
        id
        title
      }
      periodFrom
      periodTo
      invoiceDate
      expiredAt
      paidAt
      status
      expired
      note
      invoiceUrl
      invoice {
        number
        issuedAt
        sentAt
        sentTo
        previousNumbers {
          number
          issuedAt
          reason
        }
      }
      amount {
        value
        currency
      }
      amountInOrganizationCurrency {
        value
        currency
      }
      exchangeRate {
        rate
        date
        source
      }
      invoiceAmount {
        value
        currency
      }
      invoiceExchangeRate {
        rate
        date
        source
      }
      lines {
        itemType
        title
        amount {
          value
          currency
        }
        amountInOrganizationCurrency {
          value
          currency
        }
        reportId
        report {
          id
          period
          status
        }
      }
    }
    count
  }
}
